import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { firebase } from '../firebase';
import * as routes from '../constants/routes';
import { getRoles } from '../store/roles/actions';
import { ROLE_RENTER } from '../constants/roles';
import { handleError } from '../store/infos/actions';

const withAuthorization = authCondition => (Component) => {
  class WithAuthorization extends React.Component {
    state = {};

    static getDerivedStateFromProps(props) {
      let newState = null;
      if (!props.roles) {
        props.getRoles();
      }

      firebase.auth.onAuthStateChanged((authUser) => {
        if (!authCondition(authUser)) {
          props.history.push(routes.SIGN_IN);
        }
      });

      if (props.roles && props.authUser) {
        const role = props.roles[props.authUser.uid]
          ? props.roles[props.authUser.uid] : 0;
        if (role < ROLE_RENTER) {
          firebase.auth.signOut()
            .then(() => {
              props.history.push(routes.SIGN_IN);
            })
            .catch((error) => {
              props.handleError(error);
            });
        }
      }
      return newState;
    }

    render() {
      if (this.props.authUser && !this.props.pending && this.props.roles) {
        return (
            <Component {...this.props}/>
        );
      }
      return null;
    }
  }

  const mapStateToProps = state => ({
    authUser: state.users.authUser,
    roles: state.roles.content,
    pending: state.roles.pending,
  });

  return compose(
    withRouter,
    connect(mapStateToProps, { getRoles, handleError }),
  )(WithAuthorization);
};

export default withAuthorization;



// WEBPACK FOOTER //
// ./src/hoc/withAuthorization.jsx